import landing from "./landing";
import auth from "./auth.ts";
import registration from "./registration.ts";
import balance from "./balance.ts";
import organization from "./organization";
import shop from "./shop";
import tariff from "./tariff";
import employee from "./employee";
import documents from "./documents";
import history from "./history";
import clients from "./clients";
import wallet from "./wallet";

import files from "./files";
import catalog from "./catalog";

export default {
  auth,
  registration,
  balance,
  organization,
  shop,
  landing,
  tariff,
  employee,
  documents,
  history,
  clients,
  wallet,
  catalog,

  files,

  //SYSTEM
  sys: {
    error: "Қате: ",
    descError: "Сипаттама: ",
    wrongLogin: "Қате логин",
    wrongPass: "Қате пароль",
    unknown: "Белгісіз",
    unauthenticated: "Авторизацияланбаған",
    iikAlready: "Бұл ИИК бар заңды тұлға бұрыннан бар",
    noMoney: "Баланста қаражаты жеткіліксіз",
    wrongPeriod: "ProPlus тек жылға",
    noPermissions: "Пайдаланушыда қажетті рұқсаттар жоқ.",
    firstLoginManager: "Алғаш рет кірілді, парольді ойлап табыңыз",
    limitShops: "Сауда нүктесін құру тариф бойынша шектеулі",
    limitLegalEntity: "Заңды тұлғаны құру тариф бойынша шектеулі",
    wrongTariff: "Сіздің тарифіңізде бұл қолжетімді емес",
    wrongTariffPromo: "Промокод тіркелуге жарамсыз",
    tagExist: "Бұл тег бұрыннан бар",
    503: "Сервер қолжетімді емес",
    blockManager: "Менеджер бұғатталған",
    wrongCode: "Қате код",
    codeExists: "Әріптес промокоды қате енгізілді",
    noExam: "Емтихан тапсырылмаған",
    noActivateAccount: "Есептік жазба белсендірілмеген",
    emailExist: "Бұл поштамен иесі RC GROUP сервистерінде бұрыннан тіркелген",
    userExist: "Бұл поштамен иесі RC GROUP сервистерінде бұрыннан тіркелген",
    noAccepted: "Жаңа келісім қабылданбады",
    balanceNotEnough: "Баланста қаражаты жеткіліксіз",
    innExist: "Бұл ИНН бар заңды тұлға бұрыннан бар",
    noTodayChangeTariff:
      "Тарифті өзгертуге болады тек ағымдағы тарифтің аяқталуына бір күн қалғанда",
    badToken: "Бұл сілтеме жарамсыз",
    wrongEmail: "Қате пошта",
    emailTaken: "Электрондық пошта бос емес",
    notAvailableCurrentTariff: "Ағымдағы тариф үшін қолжетімді емес",
    dataNoCorrect: "Деректер дұрыс емес",
    accountNotFound: "Есептік жазба табылмады",
    TPExist: "Сауда нүктесі бұрыннан бар",
    serverError: "Сервер қатесі",
    ownerExist: "Есептік жазба табылмады",
    unauthorizedAction: "Сізде жеткілікті құқықтар жоқ",
    legalEntityExist: "Заңды тұлға табылмады",
    tariffChangeOneDay:
      "Тарифті өзгертуге болады тек ағымдағы тарифтің аяқталуына бір күн қалғанда",
    blockedByTariff: "Тариф бойынша бұғатталған",
    documentInProcessOfCreation: "Құжат құру процесінде",
    emailAlreadyVerified: "Сіздің поштаңыз бұрыннан расталған!",
    emailConfirmed: "Сіздің поштаңыз сәтті расталды!",
    codeDoesNotExist: "Енгізілген код жарамсыз",
    defaultCashbackCanNotBeDeleted:
      "Брендтік картасы жоқ клиенттерге берілетін сыйақы жойылуы мүмкін емес",
    cashbackUpdateSuccessful: "Сыйақы пайызы сәтті жаңартылды",
    cashbackDeleteSuccessful: "Сыйақы жойылды",
    cashbackCreateSuccessful: "Сыйақы құрылды",
    fullCashback: "Брендтік картасы жоқ клиент",
    clientGroupAlreadyInUse:
      "Клиенттер тобы кешбек тобында бұрыннан қолданылуда",
    enteredAmountIsAlreadyInUse: "Енгізілген сыйақы сомасы бұрыннан енгізілген",
    dateStartIsInvalid: "Кезең басталу күні қате енгізілді",
    dateEndIsInvalid: "Кезең аяқталу күні қате енгізілді",
    organizationNotConfirmed: "Заңды тұлға расталмаған",
    periodNotAvailable: "Таңдалған кезең сатып алу үшін қолжетімді емес",
    notAvailableInYourCountry: "Таңдалған кезең сатып алу үшін қолжетімді емес",
    exceededActivatedPromotionLimit:
      "Бір сауда нүктесіне тек 3 белсендірілген акция",
    tradingPointLimitOnProPlus:
      "ProPlus тарифінде 30-нан аспайтын сауда нүктесін құруға болады",
    tradingPointLimitOnPromo:
      "ProPlus тарифінде 15-тен аспайтын сауда нүктесін құруға болады",
    tradingPointLimitOnLight:
      "ProPlus тарифінде 5-тен аспайтын сауда нүктесін құруға болады",
    wrongDateOrder: "Кезең басталу күні аяқталу күнінен ертерек болуы керек",
    descriptionFormatInvalid: "Сипаттамада хештегтер мен эмоджи болмауы керек",
    descriptionMustNotContainEmoji: "Сипаттамада эмоджи болмауы керек",
    descriptionMinLength:
      "Сипаттама бос орындарды есептемей 600 таңбадан ұзынырақ болуы керек",
    descriptionMaxLength: "Сипаттама 3000 таңбадан ұзын болмауы керек",
    maxFileSizeError: "Файл мөлшері 10 Мб шектен асып кетті",
    addFile:
      "Сүйреңіз немесе <span style='color: #447ECB; cursor: pointer'>файлдарды жүктеңіз</span>",
    balance: "Баланс",
    changeMainOrganizationError:
      "Негізгі ұйымды өзгертуге болады тек алдыңғы өзгертуден кейін 30 күн өткен соң",
    resetWallet: "Wallet pass дизайнын сәтті қалпына келтіру мүмкін болмады",
    updateWallet: "Wallet pass дизайнын сәтті жаңарту мүмкін болмады",
    userUnauthorized: "Логин немесе пароль қате енгізілді",
    noData: "Деректер жоқ",
    kb: "КБ",
    dateMask: "кк.aa.жжжж",
    sort: "Сұрыптау",
    noDataTitle: "Деректер әлі жоқ",
    syncError: "Синхронизацияда проблема. Кейінірек қайталап көріңіз.",

    enterName: "Атауын енгізіңіз",
    countries: {
      ru: "Ресей",
      kz: "Қазақстан",
      md: "Молдова",
      ky: "Қырғызстан",
      uz: "Өзбекстан",
    },
    select_country: "Елді таңдаңыз",
    country: "Ел",
    q_date: {
      days: "Жексенбі_Дүйсенбі_Сейсенбі_Сәрсенбі_Бейсенбі_Жұма_Сенбі",
      daysShort: "Жк_Дс_Сс_Ср_Бс_Жм_Сб",
      months:
        "Қаңтар_Ақпан_Наурыз_Сәуір_Мамыр_Маусым_Шілде_Тамыз_Қыркүйек_Қазан_Қараша_Желтоқсан",
      monthsShort: "Қңт_Ақп_Нау_Сәу_Мам_Мау_Шіл_Там_Қыр_Қзн_Қрш_Жлт",
    },
    errorTitle: "Бірдеңе дұрыс болмады",
    dateFrom: "Деректер қолжетімді ",
    dateToToday: " бастап бүгінгі күнге дейін",
    dateFormat: "Формат кк.aa.жжжж немесе кк.aa.жжжж - кк.aa.жжжж",
    showBy: "Көрсету: ",
    showByMobile: "Бойынша: ",
    searchResponseEmpty: "Сіздің сұранысыңыз бойынша ештеңе табылмады",
    search: "Іздеу",
    imageSize: "Мб",
    tagSearchResponseEmpty:
      "Тег табылмады. Оны қосу үшін Enter немесе Бос орын пернесін басыңыз.",
    from: "Бастап:",
    to: "Дейін:",
    gender: {
      m: "Ер",
      f: "Әйел",
    },
    500: "Бірдеңе дұрыс болмады. Интернет байланысын тексеріңіз.",
    soon: "Жақында!",
    fromToPercent: "{from} дейін {to} %",
    fromToDays: "{from} дейін {to} күн",
    timeFormat: "сс:мм – сс:мм",
  },

  message: {
    changesSavedAndSendedToModeration:
      "Өзгерістер сақталды және модерацияға жіберілді",
  },

  entity: {
    title: "Ұйым деректерін қосыңыз",
    thirdStepTitle:
      "Деректердің дұрыстығын тексеріңіз. Енді сізге 24-48 сағат күту керек, біз сіздің заңды тұлғаңызды растаймыз.",
    accept: "Мен келісім шарттарын қабылдаймын",
    offers: "оферта",
    titleReject: "Өтініш қабылданбады!",
    rejectDescription:
      "Өкінішке орай, сіз берген деректер дұрыс емес болып шықты. Модераторлардың жауабымен мұқият танысып, заңды тұлға туралы ақпаратта өзгерістер енгізіңіз.",
    message: "Модераторлардың хабарламасы:",
    change: "Деректерді өзгерту",
    titleWaiting: "Тіркелгеніңіз үшін рахмет!",
    descriptionWaiting:
      "Қазір сіздің ұйымыңыз модерациядан өтуде. Біз деректеріңіздің дұрыстығына көз жеткізгеннен кейін сіз жеке кабинетке кіре аласыз. Әдетте тексеру 24-48 сағатты алады.",
    descriptionWaitingRu:
      "<p>Қазір сіздің ұйымыңыз модерациядан өтуде. </p> <p>Біз деректеріңіздің дұрыстығына көз жеткізгеннен кейін сіз RC Group партнерінің кабинетіне кіре аласыз. </p>  <p> Әдетте тексеру 24-48 сағатты алады.</p>",
    descriptionWaitingRuWithoutPos:
      "<p>Қазір сіздің ұйымыңыз модерациядан өтуде. </p> <p>Біз деректеріңіздің дұрыстығына көз жеткізгеннен кейін сіз RC Group партнерінің кабинетіне кіре аласыз. </p> <p> Әдетте тексеру 24-48 сағатты алады.</p>",
    downloadAccept: "Төлем шотын жүктеу",
    addDone: "Заңды тұлғаны құрғаныңызбен құттықтаймыз!",
    waitingApprove:
      "<p>Қазір сіздің заңды тұлғаңыз тексерілуде. Бұл 24-48 сағатты алады.</p><p>Тексеруден өту үшін төмендегі батырманы басу арқылы көрсетілген заңды тұлғадан төлем шотын төлеуіңіз керек. Сіз сондай-ақ шотты жеке кабинеттегі «Менің кәсіпорындарым» - «Құжаттар» бөлімінде «Тестілеу төлемі» атауымен таба аласыз.</p>",
  },

  contacts: {
    title: "Байланыстар",
    subtitle:
      "<span>«АҚПАРАТТЫҚ-ҚАРЖЫЛЫҚ ТЕХНОЛОГИЯЛАР КОРПОРАЦИЯСЫ» АКЦИОНЕРЛІК ҚОҒАМЫ (АҚ «Инфинтех корпорациясы»)</span><span>Заңды мекенжайы: 191124, Ресей, Санкт-Петербург қ., Красного Текстильщика көш., 10-12 үй, литера О, 6-қабат, 1-н бөлме, 624-кабинет </span><span>ИНН/КПП 7842216564/784201001 ОГРН 1237800080616</span>",

    mailAddress: "Электрондық поштаның мекенжайы: ",
  },

  failed: "Қате. Әрекет орындалмады",
  success: "Әрекет орындалды",

  //cabinet layout
  leftPanel: {
    counterparties: "Контрагенттерді тексеру",
    entities: "Заңды тұлғалар",
    tradingPoint: "Сауда нүктелері",
    paymentMethods: "Төлем әдістері",
    employees: "Кассирлер",
    documents: "Құжаттар",
    businesses: "Бизнес",
    tariffs: "Тарифтер",
    historyPayment: "Операциялар тарихы",
    promotions: "Акциялар",
    actsAndAccounts: "Акттер мен шоттар",
    accrualCashback: "Баллдар есептеу",
    managers: "Менеджерлер",
    spread: "RC карталарын тарату",
    analytics: "Аналитика",
    points: "Кассирлерге ұпайлар",
    enterprises: "Менің кәсіпорындарым",
    paymentDecision: "Төлем шешімі",
    portfolio: "Портфель",
    employees_and_managers: "Менің қызметкерлерім",
    loyalty: "Садқарлық бағдарламасы",
    clients: "Клиенттер",
    claims: "Өтініштер",
    claims_history: "Өтініштер тарихы",
    claims_groups: "Клиенттерді топтастыру",
    reviews: "Пікірлер",
    extendTariff: "Тариф әрекетін ұзартыңыз",
    changeTo: "тариф өзгереді",
    wallet: "Wallet картасының дизайны",
    accountIs: "Сіз кірдіңіз",
    manager: "менеджер",
    owner: "иесі",
    terminals: "Касса аппараттары",
    terminals_MSPOS: "RC Processing 4 бірде",
    terminals_LIMON: "MPOS технологиясы",
    FAQ: "RC CITY туралы егжей-тегжейлі",
    corporate: "Байланыс",
    push: "Wallet Push-хабарландырулар",
    tips: "Қолма-қолсыз көңілбақшалар",
    eMenu: "Онлайн-каталог",
    documentLaboratory: "Құжаттар зертханасы",
    giftCard: "Сыйлық карталары",
    processing: "Processing",
    services: "Сервистер",
    wallets: "Садқарлық карталары",
    clientsList: "Клиенттер тізімі",
    marketplaces: "Маркетплейстер",
    PromotionServices: "Жарнамалау",
    PreOrders: "Тапсырыстар",
    PWA: "Қолданбаны орнату",
    tgNotifications: "Telegram-да хабарландырулар",
  },
  headerButtons: {
    addCoin: "Толтыру",
    profile: "Профиль",
    exit: "Шығу",
    themLight: "Ашық тема",
    themDark: "Қараңғы тема",
  },

  // Managing managers page
  managers: {
    title: "Менеджерлер",
    noManagersError: "Сізде әлі менеджерлер жоқ",
    addManager: "Менеджер қосу",
    managerCreated: "Менеджер құрылды",
    managerReset: "Менеджер паролі қалпына келтірілді!",
    oneTimePass: "Бір реттік пароль",
    messageManagerCreated:
      "Назар аударыңыз! Бұл парольді жазып алыңыз, менеджердің алғашқы кірген кезінде оған жаңа пароль құру қажет болады.",
    changePass:
      "Назар аударыңыз! Бұл парольді жазып алыңыз, менеджердің алғашқы кірген кезінде оған жаңа пароль құру қажет болады",
    add: {
      title: "Менеджер қосу",
      second_name: "Менеджер тегі",
      first_name: "Менеджер аты",
      patronymic: "Менеджер әкесінің аты",
      position: "Менеджер лауазымы",
      phone: "Менеджер телефон нөмірі",
      permissions: "Кабинет беттеріне қатынасу",
      button: "Менеджер құру",
    },
    //change
    changeTitle: "Менеджерді өзгерту",
    buttonChange: "Менеджер деректерін өзгерту",
    buttonResetPassword: "Парольді қалпына келтіру",
    //reset password
    newPassword: "Жаңа парольді енгізіңіз",
    newPassRules1: "Кемінде 8 таңбадан тұруы керек",
    newPassRules2: "Латын әліпбиінің әріптері мен сандарын қамтуы керек",
    //delete manager
    deleteManager: "Менеджерді жоюға сенімдісіз бе?",
  },
  //check counterparties page
  counterparties: {
    title: "Контрагенттерді тексеру",
    buttonCheck: "Тексеру",
    question:
      "Тіркеу күні, ИНН, КПП, ОГРН, Негізгі қызмет түрі, Заңды тұлға статусы, ИФНС, Заңды мекен-жай, Бас директор, Құрылтайшылар, Жарғылық капитал",
    instructionButton: "Контрагенттерді тексеру нұсқаулығы",
    listTitle: "Контрагенттерді тексеру үшін Ботты қалай пайдалануға болады?",
    listItemFirst: "Тексергіңіз келетін ұйымның ИНН немесе ОГРН енгізіңіз.",
    listItemSecond: "Telegram-Бот сізге барлық қажетті ақпаратты көрсетеді.",
    listItemThird:
      "Бұғатталған шоттарды тексеру үшін «Шоттарды бұғаттауды тексеру» батырмасын басу керек.",
    listItemFourth:
      "«Шоттарды бұғаттауды тексеру» батырмасын басқаннан кейін Бот барлық бұғатталған шоттарды (егер болса), ФНС, бұғаттау күні, № бұйрық, негіздемесін мақала бойынша көрсетеді. Бұл ақпаратты PDF форматында жүктеп алуға болады: «Есеп файлын жүктеу» батырмасын басыңыз.",
    instructionCardTitleFirst: "Контрагенттерді неге тексеру керек?",
    instructionCardTitleSecond: "Фактілерді дер кезінде біліңіз.",
    instructionCardTextFirst:
      "<p>Контрагенттерді тексеру контрагентпен жұмыс істеу кезінде пайда болуы мүмкін қаржылық және салықтық тәуекелдерді уақытында анықтау және негізделген шешім қабылдау үшін қажет - ынтымақтастықты жалғастыру немесе тоқтату. <br> Бот жаңа және ағымдағы контрагенттерді әртүрлі дереккөздер бойынша автоматты түрде тексереді және сізге сыни факторлар мен назар аударуды қажет ететін мәліметтер туралы хабарлайды.</p>",
    instructionCardTextSecond:
      "<p>Бот арқылы сіз контрагенттердің барлық базасы бойынша немесе нақты бөлінген бойынша жалпы топтамалы тексеру және өзгерістерді мониторинг жүргізе аласыз. Бұл клиенттер мен серіктестердегі маңызды өзгерістерге уақытылы жауап беруге мүмкіндік береді, ақша қаражаттарын қайтарбау тәуекелін азайтады.</p>",
  },

  // Claims and history claims page
  claims: {
    title: "Өтініштер",
    historytitle: "Өтініштер тарихы",
    group_name: "Топ атауы",
    group_nomination: "Топ атауы",
    group_sum: "Сатып алу сомасы (жеңілдіктерсіз)",
    create_group: "Жаңа топ құру",
    edit_group: "Топты өңдеу",
    delete_group: "Топты жоюға сенімдісіз бе?",
    sum: "Сома",
    percent: "Есептеу пайызы",
    noClients: "Сізде әлі бір де клиент болған жоқ",
    oneClient: "Сізде тек бір клиент болған",
  },
  // Reviews page
  review: {
    title: "RC PAY пікірлері",
    pageHint:
      "Бұл ішкі бөлім кеңселеріңіздің қонақтарынан кері байланыс жинауға арналған, ол rcpay.ru сайтында орналастырылады. Қандай пікірлерді көрсетуге басқару үшін «көз» белгішесін басу арқылы өзіңіз басқара аласыз",
    goodFirst: "Алдымен жақсылар",
    badFirst: "Алдымен жамандар",
    newFirst: "Жаңалығы бойынша",
    noTradingPointsData: "Пікірлерді көру үшін сауда нүктесін құру керек",
    hint: "Пікір күндер бойынша сүзгіге байланысты",
    noReviews: "Сізде әлі пікірлер жоқ",
    all: "Барлық пікірлер",
    shown: "Көрсетілетіндер",
    hidden: "Жасырылғандар",
    hideStatus:
      "rcpay.ru сайтындағы сауда нүктесінің парағынан жасыру керек пе?",
    showStatus:
      "rcpay.ru сайтындағы сауда нүктесінің парағында көрсету керек пе?",
    noDataLabel: "Пікірлер бойынша деректер жоқ",
    noTradingPointText: "Сізде әлі Сауда нүктелері жоқ",
    noReview:
      "Пайдаланушылар әлі Сіздің сауда нүктеңіз туралы пікір қалдырған жоқ",
  },

  //analytic page
  analytics: {
    title: "Аналитика",
    organizationSelect: "Заңды тұлғаны таңдаңыз",
    organizationButton: "Заңды тұлғалар",
    organizationCheckbox: "Барлық ұйымдар",
    newOrganizationCheckbox: "Барлық Заңды тұлғалар",
    calendar: "Күнтізбе",
    organizations: {
      newClients: "Жаңа клиенттер",
      allClients: "Барлық клиенттер",
      sales: "Сатылымдар",
      amount: "Сатылым сомасы",
      amountCashback: "Оның ішінде баллдармен берілген",
      average: "Орташа чек",
      averageCashback: "Орташа сыйақы",
    },
    countClients: "Клиенттер саны",
    topSumEmployee: "Сатылым сомасы бойынша үздік кассирлер",
    topSaleEmployee: "Сатылымдар бойынша үздік кассирлер",
    points: "Ұпайлар",
    addPoints: "Есептелген баллдар",
    writePoints: "Баллдармен қабылданған",
    rfmAnalysis: "RFM талдау",
    rfmGroupSizes: "RFM топтар өлшемі",
    clientPortrait: {
      btn: "Клиент портреті",
      title: "Клиенттер",
      customerCount: "Клиенттер саны:",
      receiptAvg: "Орташа чек:",
      receiptCount: "Сатылымдар саны:",
      receiptSum: "Сатылымдар сомасы:",
      maleFemale: "Е/Ә:",
      noGender: "Жынысы көрсетілмеген:",
    },
  },

  // Cashback page
  cashback: {
    title: "Баллдар есептеу",
    subTitle:
      "<b>Назар аударыңыз!</b><br><b>FREE</b> тарифіндегі клиенттер <b>25%</b> алады,<br> <b>SMART</b> тарифіндегі клиенттер <b>50%</b> алады,<br> Сіздің <b>сандықтандырылған</b> клиенттеріңіз <b>50%</b> алады<br> (комиссия алынбайды)<br><br><a href='/public/docs/reward_scenario_1.0.pdf' target='_blank'>Сыйақы бөлу сценарийлерін қараңыз</a>",
    statusName: "Брендтік картасы жоқ клиенттер",
    delay: "Есептеулердің кешігуі (күндерде)",
    setDelay: "Кешіктіруді өзгерту",
    editDelay: "Есептеулердің кешіктіруін өзгерту",
    maxDelay: "Максималды кешіктіру 14 күн",
    setReward: "Сыйақыны орнату",
    selectGroup: "Топты таңдаңыз",
    rewardPercent: "Есептеу пайызын енгізіңіз",
    minReward: "Есептеудің минималды пайызы - 4",
    maxReward: "Есептеудің максималды пайызы - 25",
    delayTitle: "Сауда нүктесінің ағымдағы кешіктіруі:",
    withoutActiveWait:
      "Сіздің пайдаланушыңыз операция өткізілген сәттен бастап 30 минут ішінде сыйақы алады",
  },

  // Spread page
  spread: {
    title: "RC карталарын тарату",
    p1: "Бұл кодты сканерлеп, клиенттеріңіз карта ала алады.",
    inviteClients: "Клиенттерді шақыру",
    p2: "Біз QR-кодты және «Бонуслық картаны жүкте! Бонуслық баллдар жина және сатып алуға арнайы жағдайлар алыңыз» жазуы бар үстелдік тентті кассаның жанында немесе сатып алушыларыңыз есептесетін орынның жанында орналастыруды ұсынамыз. Мысалы, кафедегі үстелдерде, дүкендегі кассаның жанындағы күту аймағында немесе клиенттеріңіз бұл ақпаратты сөзсіз көретіндей басқа орында.",
    getCard: "Сілтеме бойынша карта алу",
    ttl1: "RC KASSA арқылы карта алу",
    p4: "Өзіңіздің QR-кодыңызды көрсету үшін RC KASSA қолданбасын пайдаланыңыз: ол үшін «Wallet картасын беру» мәзір пунктіне өтіңіз. Клиентке телефонмен кодты сканерлеуді ұсыныңыз. Картаны осылай алу қарапайым болғанымен, біз QR-кодты басып шығарып, кассаның жанында әрекетке шақырумен бірге орналастыруды ұсынамыз.",
    ttl2: "Қызметкерлермен жұмыс",
    p5: "Әлемдік тәжірибе көрсеткендей, қызметкерлер жиі садқарлық бағдарламаларын енгізуді бойкоттайды. Бұл тек ескірген пластикалық емес, сонымен қатар RC Group сияқты цифрлық шешімдерге де қатысты. Көптеген қызметкерлерге садқарлық бағдарламасы туралы клиенттерге айту арқылы олар ұйымның түсімін азайтады деп көрінуі мүмкін. Бұл мәлідеме жалған. Садқарлық бағдарламасының таралуы неғұрлым жоғары болса, орташа чек, сатып алу жиілігі және брендке деген сенім соғұрлым жоғары болады. Сонымен қатар, бағдарламаның жоғары таралуы бизнестің SMS және басқа жіберулерге кеткен шығындарын азайтуға мүмкіндік береді және өз клиенттерін жақсырақ білуге көмектеседі.",
    coped: "Көшірілді",

    faq: [
      {
        title: "Орналастыру",
        text: "Біз QR-кодты және «Бонуслық картаны жүкте! Бонуслық баллдар жина және сатып алуға арнайы жағдайлар алыңыз» жазуы бар үстелдік тентті кассаның жанында немесе сатып алушыларыңіз есептесетін орынның жанында орналастыруды ұсынамыз. Мысалы, кафедегі үстелдерде, дүкендегі кассаның жанындағы күту аймағында немесе клиенттеріңіз бұл ақпаратты сөзсіз көретіндей басқа орында.",
      },
      {
        title: "RC KASSA арқылы карта алу",
        text: 'Өзіңіздің QR-кодыңызды көрсету үшін RC KASSA қолданбасын пайдаланыңыз: ол үшін жоғарғы оң жақ бұрыштағы үш қара нүктені басып, "QR-кодты ашу" таңдаңыз. Клиентке телефонмен кодты сканерлеуді ұсыныңыз.',
      },
      {
        title: "Қызметкерлермен жұмыс",
        text: "Әлемдік тәжірибе көрсеткендей, қызметкерлер жиі садқарлық бағдарламаларын енгізуді бойкоттайды. Бұл тек ескірген пластикалық емес, сонымен қатар RC Group сияқты цифрлық шешімдерге де қатысты. Көптеген қызметкерлерге садқарлық бағдарламасы туралы клиенттерге айту арқылы олар ұйымның түсімін азайтады деп көрінуі мүмкін. Бұл мәлідеме жалған. Садқарлық бағдарламасының таралуы неғұрлым жоғары болса, орташа чек, сатып алу жиіліği және брендке деген сенім соғұрлым жоғары болады. Сонымен қатар, бағдарламаның жоғары таралуы бизнестің SMS және басқа жіберулерге кеткен шығындарын азайтуға мүмкіндік береді және өз клиенттерін жақсырақ білуге көмектеседі.",
      },
    ],

    faqNko: [
      {
        title: "Орналастыру",
        text: "Біз QR-кодты және «Бонуслық картаны жүкте! Бонуслық баллдар жина және сатып алуға арнайы жағдайлар алыңыз» жазуы бар үстелдік тентті кассаның жанында немесе сатып алушыларыңіз есептесетін орынның жанында орналастыруды ұсынамыз. Мысалы, кафедегі үстелдерде, дүкендегі кассаның жанындағы күту аймағында немесе клиенттеріңіз бұл ақпаратты сөзсіз көретіндей басқа орында.",
      },
      {
        title: "Қызметкерлермен жұмыс",
        text: "Әлемдік тәжірибе көрсеткендей, қызметкерлер жиі садқарлық бағдарламаларын енгізуді бойкоттайды. Бұл тек ескірмен пластикалық емес, сонымен қатар RC Group сияқты цифрлық шешімдерге де қатысты. Көптеген қызметкерлерге садқарлық бағдарламасы туралы клиенттерге айту арқылы олар ұйымның түсімін азайтады деп көрінуі мүмкін. Бұл мәлідеме жалған. Садқарлық бағдарламасының таралуы неғұрлым жоғары болса, орташа чек, сатып алу жиілігі және брендке деген сенім соғұрлым жоғары болады. Сонымен қатар, бағдарламаның жоғары таралуы бизнестің SMS және басқа жіберулерге кеткен шығындарын азайтуға мүмкіндік береді және өз клиенттерін жақсырақ білуге көмектеседі.",
      },
    ],
  },

  // Push notifications page
  notifications: {
    title: "Push-хабарландырулар",
    modal:
      "Жіберу өңделуде, Сіздің пайдаланушыларыңыз 15 минут ішінде push-хабарландыру алады",
    description:
      "Мәтінді мұқият оқыңыз. Хабарландыруды құрғаннан кейін оны өзгерту <span>мүмкін болмайды.</span>",
    notificationText: "Хабарландыру мәтіні",
    sendError: "Push-хабарландыруды жіберу сәтсіз аяқталды",
    sendTime: "Мәскеу уақыты бойынша",
    noNotifications: "Сізде құрылған push-хабарландырулар жоқ",
    buttonNoData: "PUSH-хабар құру",
    table: {
      shopName: "Сауда нүктесінің атауы",
      header: "Тақырып",
      date: "Күні",
      time: "Уақыты",
    },

    view: {
      shop: "Сауда нүктесі",
      header: "Тақырып",
      message: "Хабар мәтіні",
      date: "Күні",
      time: "Уақыты",
    },

    create: {
      warning:
        "Мәтінді мұқият оқыңыз. Хабарландыруды құрғаннан кейін оны өзгерту <span>мүмкін болмайды.</span>",
      shop: "Сауда нүктесін таңдау",
      header: "Тақырып мәтіні",
      message: "Хабар мәтіні",
      button: "Жіберу құру",
      messageAfterCreate:
        "Жіберу өңделуде, Сіздің пайдаланушыларыңыз 15 минут ішінде push-хабарландыру алады",
    },
  },

  // Answer moderation
  status: {
    moderation: "Модерацияда",
    confirmation: "Расталды",
    confirm: "Расталған",
    reject: "Қабылданбады",
    reject2: "Қабылданбаған",
    paid: "Төленген",
    active: "Белсенді",
    locked: "Бұғатталған",
    activateProcess: "Белсендіру процесінде",
    awaitingPayment: "Төлем күтілуде",
    sent: "Жіберілген",
    received: "Қабылданған",
    canceled: "Бас тартылған",
    unknown: "Белгісіз",
    awaitingDocs: "Құжат жүктелуін күтуде",
    base: "Негізгі",
    inProgress: "Жұмыс барысында",
    completed: "Аяқталған",
    new: "Жаңа",
    readyForIssue: "Беруге дайын",
    issuedToClient: "Клиентке берілген",
    undefined: "Анықталмаған",
    performed: "Өткізілген",
    inWaiting: "Күтуде",
  },

  // Table
  table: {
    searchByTable: "Кесте бойынша іздеу",
    status: "Статус",
    nameStatus: "Статус атауы",
    percentageAccrual: "Есептеу пайызы",
    fullName: "АЖ",
    position: "Лауазымы",
    phone: "Телефон нөмірі",
    login: "Логин",
    number: "Нөмірі",
    sum: "Сома",
    customer: "Сатып алушы",
    cashback: "Баллдар",
    currency: "Валюта",
    dateTime: "Күні және уақыты",
    date: "Күні",
    paid: "Төленген",
    purchase: "Сатып алу бағасы",
    transaction: "Транзакция",
    type: "Түрі",
    points: "Ұпайлар",
    name: "Аты",
    visits: "Келу жиілігі",
    averageCheck: "Сатылымдар сомасы",
    birthday: "Туған күні",
    age: "Жасы",
    nameAndSurname: "Тегі және Аты",
    store: "Сауда нүктесі",
    entityName: "Ұйым атауы",
    operationType: "Операция түрі",
  },

  // Common text
  common: {
    nodata: "Сізде әлі сауда нүктесі жоқ",
    buttonNoData: "Сауда нүктесін құру",
    organizationSelect: "Ұйымды таңдаңыз",
    allOrganizationCheckbox: "",
    tradingPointsSelect: "Сауда нүктесін таңдаңыз",
    allTradingPointsCheckbox: "Барлық сауда нүктелері",
    from: "бастап",
    util: "дейін",
    to: "дейін",
    fillField: "Бұл өрісті толтырыңыз",
    invalidEmail: "Қате пошта",
    minLengthPass: "Пароль 8 таңбадан кем емес",
    fillTime: "Уақытты толтырыңыз",
    calendar: "Күнтізбе",
    filter: "Сүзгі",
    filters: "Сүзгілер",
    back: "Артқа",
    loadDescription: "Өнімнің халал сертификатын жүктеңіз:",
    loadFormat: ".PDF .JPG .PNG форматындағы сертификатар қолдау көрсетіледі",
    loadSize: "Файл салмағы 10 МБ аспауы керек",
    dropFiles: "Файлды осы жерге сүйреңіз немесе",
    uploadFiles: "жүктеңіз",
    chooseFile: "Файлды таңдау",
    fileName: "Файл атауы",
    Monday: "Дүйсенбі",
    Tuesday: "Сейсенбі",
    Wednesday: "Сәрсенбі",
    Thursday: "Бейсенбі",
    Friday: "Жұма",
    Saturday: "Сенбі",
    Sunday: "Жексенбі",
    MondayShort: "Дс",
    TuesdayShort: "Сс",
    WednesdayShort: "Ср",
    ThursdayShort: "Бс",
    FridayShort: "Жм",
    SaturdayShort: "Сн",
    SundayShort: "Жк",
    1: "Дүйсенбі",
    2: "Сейсенбі",
    3: "Сәрсенбі",
    4: "Бейсенбі",
    5: "Жұма",
    6: "Сенбі",
    7: "Жексенбі",
    dayAndNightTime: "Нүкте тәулік бойы жұмыс істейді",
    notWorkTime: "Нүкте жұмыс істемейді",
    month: "ай",
    mo: "ай",
    year: "жыл",
    organizations: "Ұйымдар",
    shops: "Сауда нүктелері",
    employees: "Кассирлер",
    managers: "Менеджерлер",
    manager: "Менеджер",
    owner: "Иесі",
    business: "Бизнес",
    tariffs: "Тарифтер",
    historyOperations: "Операциялар тарихы",
    actsAndAccounts: "Акттер мен шоттар",
    cashback: "Баллдар есептеу",
    documents: "Құжаттар",
    addBalance: "Аванстық төлем",
    addPoints: "Ұпайлар есептеу",
    application: "Касса аппаратын төлеу",
    claims: "Өтініштер",
    analytics: "Аналитика",
    sortNew: "Жаңалығы бойынша",
    sortAscStars: "Жұлдыздардың кемуі бойынша",
    sortDscStars: "Жұлдыздардың өсуі бойынша",
    email: "email",
    lastName: "Тегі",
    firstName: "Аты",
    error404: "Қате 404",
    noPage: "Бет табылмады",
    errorTypeFile: "Файл түрі дұрыс емес!",
    tryTypeFile: "Файл jpg немесе png болуы керек",
    clients: "Клиенттер",
    exitAccount: "Есептік жазбадан шығу",
    accountsForAct: "Акт бойынша шот",
    downloadOn: "қолжетімді",
    downloadOnRuStore: "жүктеңіз",
    phone: "Телефон",
    comment: "Пікір",
    pcs: "дана",
    gb: "ГБ",
    min: "мин",
    group: "Топ",
    emptyField: "Барлық өрістерді толтырыңыз",
    correctField: "Барлық өрістер дұрыс болуы керек!",
    bigFile: "Файлдың үлкен мөлшері",
    "e-menu": "Электронды мәзір",
    "document-laboratory": "Құжаттар зертханасы",
    changesNotSaved: "Енгізілген өзгерістер сақталмады",
    statuses: "Статустар",
    phoneNumber: "Телефон нөмірі",
    mail: "Электрондық пошта",
    tgBot: "Telegram бот",
  },

  // Buttons
  button: {
    invite: "Шақыру",
    download: "Жүктеу",
    edit: "Өңдеу",
    save: "Сақтау",
    saveChange: "Өзгерістерді сақтау",
    saveAndQuit: "Сақтау және шығу",
    accept: "Қабылдау",
    change: "Өзгерту",
    login: "Кіру",
    create: "Құру",
    confirm: "Растау",
    details: "Толығырақ",
    copy: "Көшіру",
    topUp: "Толтыру",
    back: "Артқа",
    send: "Жіберу",
    sendAgain: "Қайта жіберу",
    sendCode: "Код жіберу",
    next: "Келесі",
    proceed: "Жалғастыру",
    buy: "Сатып алу",
    goto: "Өту",
    open: "Ашу",
    delete: "Жою",
    cancel: "Болдырмау",
    cancel2: "Бас тарту",
    yesCancel: "Ия, болдырмау",
    yesQuit: "Ия, шығу",
    yesDelete: "Ия, жою",
    pay: "Төлеу",
    ok: "Жақсы!",
    cancelClaim: "Өтінішті болдырмау",
    generate: "Генерациялау",
    apply: "Қолдану",
    applyAndClose: "Қолдану және жабу",
    reset: "Қалпына келтіру",
    clearAll: "Барлығын тазарту",
    calendarButton: {
      today: "Бүгін",
      yesterday: "Кеше",
      lastWeek: "Соңғы 7 күн",
      last30Days: "Соңғы 30 күн",
      lastMonth: "Өткен ай",
      thisMonth: "Осы ай",
      lastYear: "Өткен жыл",
      thisYear: "Ағымдағы жыл",
      allPeriod: "Барлық кезең",
      selectRange: "Өз кезеңіңіз",
    },
    preview: "Алдын ала қарау",
    resetAll: "Барлығын қалпына келтіру",
    showResult: "Нәтижелерді көрсету",
    upload: "Жүктеу",
    expand: "Жаю",
    hide: "Жасыру",
    try: "Көру",
    add: "Қосу",
    reveal: "Көрсету",
    readAll: "Толық оқу",
    collapse: "Жию",
    logout: "Шығу",
    show: "Көрсету",
    moreDetails: "Толығырақ",
    settings: "Баптаулар",
    rollUp: "Жию",
    toTariffs: "Тарифтерге",
    forModeration: "Модерацияға",
    quitWithoutSaving: "Сақтаусыз шығу",
    downloadInvoice: "Шотты жүктеу",
    notNow: "Қазір емес",
    createCashier: "Кассир құру",
    clearly: "Түсінікті",
    toEdit: "Өңдеуге",
    skip: "Өткізіп жіберу",
    backAndSave: "Қайту және сақтау",
    done: "Дайын",
    close: "Жабу",
  },

  month: {
    1: "Қаңтар",
    2: "Ақпан",
    3: "Наурыз",
    4: "Сәуір",
    5: "Мамыр",
    6: "Маусым",
    7: "Шілде",
    8: "Тамыз",
    9: "Қыркүйек",
    10: "Қазан",
    11: "Қараша",
    12: "Желтоқсан",
  },

  charts: {
    pointsAccrued: "Есептелген баллдар",
    pointsWritten: "Баллдармен қабылданған",
  },

  eMenu: {
    noData: {
      title: "Электронды мәзір бойынша деректер жоқ",
      noTradingPoints: "Сізде әлі Сауда нүктелері жоқ",
      noProducts: "Сізде әлі бірде-бір тауар құрылмаған",
    },
  },

  validationErrors: {
    emptyField: "Өріс бос болмауы керек",
    invalidEmailFormat: "{email} тәрізді email енгізіңіз",
    invalidSiteFormat: "URL http:// немесе https:// қамтуы керек",
    invalidFormat: "Қате формат",
    incorrectValueStart: "Мән көрсетілуі керек",
    incorrectValueEnd: "дейін",
    invalidValueMaxLength: "Таңбалардың максималды саны ",
    invalidValueMinLength: "Таңбалардың минималды саны ",
    invalidHouseNumber: "Үй нөмірін нақтылаңыз",
    invalidAddress: "Мекен-жайды нақтылаңыз",
    invalidWorkDays: "Кем дегенде бір жұмыс күнін таңдау керек",
    invalidWorkTime: "Уақыт форматы қате",
    errorWorkTime:
      "Ашу уақыты жабу уақытынан кеш болмауы немесе сәйкес келмеуі керек",
    notEnoughElement: "Элементтердің жеткіліксіз саны",
    manyElement: "Сіз элементтердің максималды санынан асып кеттіңіз",
    maxLessMin: "Минималдыдан кіші",
    invalidAge: "Жарамсыз жасы",
    minDate: "Күн {date} күнінен кеш емес болуы керек",
    maxDate: "Күн {date} күнінен ерте емес болуы керек",
    requiredPhone: "Телефон нөмірін енгізіңіз",
    reqiredPromocode: "Промокод қате енгізілді",
    requiredCountry: "Елді таңдау керек",
    havePhone: "Бұл телефон бұрыннан тіркелген",
    haveMail: "Бұл пошта бұрыннан тіркелген",
    invalidEmail: "Жарамсыз пошта",
    email: "Поштаны енгізіңіз",
    first_name: "Атыңызды енгізіңіз",
    last_name: "Тегіңізді енгізіңіз",
    password: "Парольді енгізіңіз",
    corresp_account: "Корсчет көрсетілуі керек",
    number_account: "Есеп айырысу шот нөмірін көрсетіңіз",
    commercial_account_number:
      "Есеп айырысу шоты заңды тұлғаға немесе ЖКға тиесілі болуы керек",
    bik_of_bank: "Банк БИК көрсетілуі керек",
    international_bank: "Банкаралық халықаралық шот нөмірін көрсетіңіз",
    vat_code: "ҚҚС кодын көрсетіңіз",
    inn: "ИНН көрсетілуі керек",
    entityAddress: "Заңды мекен-жай көрсетілуі керек",
    fullName: "АЖ көрсетілуі керек",
    ogrn: "ОГРН көрсетілуі керек",
    monthly_turnover: "Айлық айналым мөлшерін көрсетіңіз",
    deposit_sum: "Депозит сомасын көрсетіңіз",
    tax_system: "Салық салу түрін көрсетіңіз",
    legal_type: "Заңды тұлға нысанын көрсетіңіз",
    okved_code: "Негізгі қызмет түрін көрсетіңіз",
    minFillingPhotos: "Файлдардың минималды саны - {amount}",
    notValidPromocode: "Промокод жоқ",
    cyrillicOnly: "Тек кириллица және латын әріптері",
    haveInn: "Бұл {option} бар заңды тұлға бұрыннан бар",
    addressWithoutNumber: "Ғимарат/құрылыс, бөлменің нөмірін көрсету керек",
    login: "Логинді енгізіңіз",
    empryNamedField: "{option} көрсетілуі керек",
    passwordMismatch: "Парольдер сәйкес келмейді",
    address: "Ғимарат/құрылыс, бөлменің нөмірі бар мекен-жай көрсетілуі керек",
    fieldLengthFromTo: "Өріс {from} дейін {to} саннан тұруы керек",
    necessaryEnterMinChars: "Кем дегенде {minChars} таңба енгізу керек",
    workHours: "Таңдалған күндерде жұмыс сағаттарын көрсетіңіз",
    timeFormat: "Уақыт форматы қате",
    minImagesUpload: "Кем дегенде {minImages} сурет жүктеңіз",
  },

  tooltips: {
    registration: {
      deposit:
        "Шоттағы минималды қалдық. Қаражатты алу кезінде баланста қалатын сома.",
    },
  },

  globalMessagesButton: {
    "tt-update": "Жаңа «Сауда нүктелері» ішкі бөліміне өту",
    "clients-update": "Көру",
    "product-release": "Көру",
    "review-update-release": "Көру",
  },

  declinationHelperWords: {
    years: [" жыл", " жыл", " жыл"],
    days: [" күн", " күн", " күн"],
    grades: [" баға", " баға", " баға"],
    symbols: [" таңба", " таңба", " таңба"],
    result: [" нәтиже", " нәтиже", " нәтиже"],
    review: [" пікір", " пікір", " пікір"],
    star: [" жұлдыз", " жұлдыз", " жұлдыз"],
    clients: [" клиент", " клиент", " клиент"],
    product: [" тауар", " тауар", " тауар"],
    entities: [" заңды тұлға", " заңды тұлға", " заңды тұлға"],
  },

  noData: {
    title: "Деректер жоқ",
    emptyHistory: "Сіздің тарихыңыз бос",
  },

  mobileFiltersName: {
    "trading-points": "Сауда нүктелері",
    category: "Санат",
    "product-status": "Тауар статусы",
    "review-status": "Пікір түрі",
    sort: "Сұрыптау",
    date: "Кезең",
  },

  debt: {
    title: "Қарыз",
    text: "Оны электрондық поштаға жіберілген шот арқылы төлеңіз немесе оны өзіңіз жасаңыз\n«Баланс» бөлімінде",
    link: "Өтеуге өту",
    message:
      "Сізге {debt}&nbsp;{currency} мөлшеріндегі қарызды төлеу керек <br>" +
      "Төлемді екі әдістің бірімен жүргізуге болады: жеке кабинетте шот құру немесе электрондық поштаға жіберілген шотты жүктеу.",
  },

  permissions: {
    analytics: "Аналитика",
    "legal-entity": "Заңды тұлғалар",
    "trading-point": "Сауда нүктелері",
    employee: "Кассирлер",
    document: "Құжаттар",
    tariff: "Тарифтер",
    operation: "Операциялар тарихы",
    "act-and-receipt": "Акттер мен шоттар",
    manager: "Менеджерлер",
    cashback: "Баллдар есептеу",
    balance: "Баланс",
    points: "Кассирлерге ұпайлар",
    client: "Клиенттер тізімі",
    spread: "Wallet карталарын тарату",
    "wallet-pass": "Wallet картасының дизайны",
    review: "Пікірлер",
    "noncash-tips": "Қолма-қолсыз көңілбақшалар",
    "check-counterparties": "Контрагенттерді тексеру",
    "push-notifications": "Push-хабарландырулар",
    "client-portrait": "Клиент портреті",
    "active-wait": "Баллдар есептеу (Белсенді күту)",
    "e-menu": "Электронды мәзір",
    "tg-notifications": "Telegram-да хабарландырулар",
    faq: "ЖҚС",
    terminal: "Processing",
    promotion: "Акциялар",
    cashback_group: "Баллдар есептеу (Клиенттер топтары)",
    payment_info: "Төлем әдістері",
    orders: "Тапсырыстар",
    "trading-point-promotion": "Жарнамалау",
    "gift-card": "Сыйлық карталары",
  },

  promotionServices: {
    servicesList: {
      "xxl-tag": {
        name: "XXL-өлшем карточка",
        description:
          "Мекемеңіздің карточкасының өлшемін үлкейту және оған «Топ орын» беджин орналастыру",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Мекемеңіздің карточкасының өлшемі үлкейтіліп, сонымен қатар rcpay.ru сайтының «Мекемелер» парағында және RC PAY мобильді қолданбасында оған жататын қала және санат аясында «Топ орын» беджимен бөлектеледі.</p></li>" +
          "<li><span>●</span><p>Орналастыру мерзімі – 1 апта, 1 ай немесе 3 ай партнер кабинетінде тапсырыс рәсімдеген және төлеген сәттен бастап.</p></li>" +
          "<li><span>●</span><p>Орналастыру мерзімін тапсырыс рәсімдеу кезеңінде таңдауға болады.</p></li>" +
          "<li><span>●</span><p>Бұл қызметті тапсырыс бергенде сіз сондай-ақ картада мекемеңіздің арнайы белгісін аласыз.</p></li>" +
          "</ul>",
      },
      tag: {
        name: "«Топ орын» беджи",
        description:
          "Мекемеңіздің карточкасына «Топ орын» беджин орналастыру және оны жалпы тізімде жоғарыға жылжыту",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Мекемеңіздің карточкасы «Топ орын» беджимен бөлектеліп, rcpay.ru сайтының «Мекемелер» парағында және RC PAY мобильді қолданбасында оған жататын қала және санат аясында жоғарыға жылжытады.</p></li>" +
          "<li><span>●</span><p>Орналастыру мерзімі – 1 апта, 2 апта, 1 ай немесе 3 ай партнер кабинетінде тапсырыс рәсімдеген және төлеген сәттен бастап.</p></li>" +
          "<li><span>●</span><p>Орналастыру мерзімін тапсырыс рәсімдеу кезеңінде таңдауға болады.</p></li>" +
          "<li><span>●</span><p>Бұл қызметті тапсырыс бергенде сіз сондай-ақ картада мекемеңіздің арнайы белгісін аласыз.</p></li>" +
          "</ul>",
      },
      top: {
        name: "1 немесе 2-орын",
        description:
          "Мекемеңіздің карточкасын тізімде 1 немесе 2 орынға орналастыру (оның сыртқы түрі мен өлшемін өзгертпей)",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Мекемеңіздің карточкасы rcpay.ru сайтының «Мекемелер» парағында және RC PAY мобильді қолданбасында оған жататын қала және санат аясында 1 немесе 2 орынға орналастырылады.</p></li>" +
          "<li><span>●</span><p>1 немесе 2 орынға орналастыру тапсырыс рәсімдеу және осы қызметті төлеу ретімен анықталады.</p></li>" +
          "<li><span>●</span><p>Орналастыру мерзімі – партнер кабинетінде тапсырыс рәсімдеген және төлеген сәттен бастап 2 апта.</p></li>" +
          "<li><span>●</span><p>Бұл қызметті тапсырыс бергенде сіз сондай-ақ картада мекемеңіздің арнайы белгісін аласыз.</p></li>" +
          "</ul>",
      },
      hint: "Қазіргі уақытта сауда нүктесінің қаласында осы қызмет бойынша барлық қолжетімді орындар бос емес. Тапсырыс көрсетілген күннен бастап мүмкін болады.",
    },
    periodsList: {
      "7 days": "1 апта",
      "14 days": "2 апта",
      "30 days": "1 ай (30 күн)",
      "90 days": "3 ай (90 күн)",
    },
  },
};
